var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { HDSListItem, HDSList } from "@here/hds-react-components/List";
import { HDSIcon } from "@here/hds-react-components/Icon";
import { HDSDropdown } from "@here/hds-react-components/Dropdown";
import "./dropDown.scss";
import translations from "../../translations/resources/en-GB.json";
import { MAP_COLLECTION_DROPDOWN_VALUES } from "../../pages/InternalTools/constants";
import { ORDER_MAP_3D_VIEWER } from "../../store/common/constants";
var DropDown = function (_a) {
    var itemList = _a.itemList, trigger = _a.trigger, displayListItemIcon = _a.displayListItemIcon, id = _a.id, menuWidth = _a.menuWidth, onChange = _a.onChange, value = _a.value, label = _a.label, disabledItemList = _a.disabledItemList, disabled = _a.disabled, _b = _a.itemCheckMarkSize, itemCheckMarkSize = _b === void 0 ? "medium" : _b, otherProps = __rest(_a, ["itemList", "trigger", "displayListItemIcon", "id", "menuWidth", "onChange", "value", "label", "disabledItemList", "disabled", "itemCheckMarkSize"]);
    var _c = useState(itemList[0]), selectDropdown = _c[0], setSelectDropdown = _c[1];
    var _d = useState(false), isItemSelect = _d[0], setIsItemSelect = _d[1];
    useEffect(function () {
        value ? setSelectDropdown(value) : itemList[0];
    }, [value]);
    var onSelectDropdown = function (itemIndexPayload) {
        setIsItemSelect(true);
        setSelectDropdown(itemList[itemIndexPayload.index]);
        onChange && onChange(itemList[itemIndexPayload.index]);
    };
    var styleIcon = {
        "--hds-icon-color": "var(--hds-foreground-primary)",
    };
    var disabeStyleIcon = {
        "--hds-icon-color": "var(--hds-foreground-inactive)",
    };
    var Menu = function () {
        return (_jsx(HDSList, __assign({ "data-cy": id, width: menuWidth }, { children: itemList.map(function (i, index) { return (_jsxs(HDSListItem, __assign({ disabled: (i === null || i === void 0 ? void 0 : i.includes(translations.data["venonboard.dropdown.Select"])) ||
                    (disabledItemList === null || disabledItemList === void 0 ? void 0 : disabledItemList.includes(i)) ||
                    (disabled && i === ORDER_MAP_3D_VIEWER), style: i == translations.data["venonboard.internalTools.buttonDeleteMap"]
                    ? { color: "var(--hds-negative)" }
                    : {}, "data-cy": id + index, selected: isItemSelect }, { children: [selectDropdown === i && displayListItemIcon ? (_jsx("div", __assign({ slot: "right", style: { marginLeft: "5px" } }, { children: _jsx(HDSIcon, { name: "checkmark", size: itemCheckMarkSize || "medium" }) }))) : null, i ===
                        translations.data["venonboard.internalTools.downloadCheckinReport"] || i === MAP_COLLECTION_DROPDOWN_VALUES.VIEW_QA_REPORT ? (
                    // eslint-disable-next-line react/jsx-indent
                    _jsx("div", __assign({ slot: "right", style: {
                            width: "30px",
                            justifyContent: "right",
                            display: "flex",
                            color: "var(--hds-foreground-negative)",
                        } }, { children: _jsx(HDSIcon, { name: "list-typeB", category: "discovery-sharing", size: "16px", style: disabledItemList.includes(i) ? disabeStyleIcon : styleIcon }) }))) : null, i === MAP_COLLECTION_DROPDOWN_VALUES.DOWNLOAD_STUB_LINK_REPORT ||
                        i ===
                            translations.data["venonboard.internalTools.downloadCollection"] ? (
                    // eslint-disable-next-line react/jsx-indent
                    _jsx("div", __assign({ slot: "right", style: {
                            width: "30px",
                            justifyContent: "right",
                            display: "flex",
                        } }, { children: _jsx(HDSIcon, { name: "download", category: "discovery-sharing", size: "16px", style: disabledItemList.includes(i) ? disabeStyleIcon : styleIcon }) }))) : null, i ===
                        translations.data["venonboard.internalTools.refreshCollection"] ? (_jsx("div", __assign({ slot: "right", style: {
                            width: "30px",
                            justifyContent: "right",
                            display: "flex",
                        } }, { children: _jsx(HDSIcon, { name: "refresh", style: disabledItemList.includes(i) ? disabeStyleIcon : styleIcon }) }))) : null, i] }), i + index)); }) })));
    };
    return (_jsx("div", __assign({ className: "dropDownAlign" }, { children: _jsx(HDSDropdown, __assign({ onSelect: function (i) {
                onSelectDropdown(i);
            }, onChange: function () {
                setIsItemSelect(false);
            }, trigger: trigger ? trigger : null, menu: _jsx(Menu, {}), id: id || "list-view-dropdown", "data-cy": id || "list-view-dropdown", "aria-label": label }, otherProps)) })));
};
export default DropDown;
